import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const PRESS = [
    {
        outlet: 'a16z Speedrun',
        title: 'Backed by Andreessen Horowitz',
        blurb: 'Selected for a16z Speedrun SR05. Avenir raised seven figures and signed Fortune 500 and top-5 broker customers with zero marketing spend.',
        img: 'https://cdn.sanity.io/images/tzetulnq/production/9980438b30f7722c01ea83f9e82699761732dfba-1920x1080.png',
        href: 'https://speedrun.a16z.com/companies/avenir-ai',
        cta: 'View on Speedrun',
    },
    {
        outlet: 'The Weekend Read',
        title: 'An MIT-born startup built at the edge of two crises',
        blurb: 'A feature profile on how Avenir’s MIT founders are rebuilding a $1.9T employee-benefits industry that still runs on manual work.',
        img: 'https://static.wixstatic.com/media/74c2cc_84dab72beec14e3d828c03376ef8a321~mv2.png/v1/fill/w_1200,h_675,al_c/74c2cc_84dab72beec14e3d828c03376ef8a321~mv2.png',
        href: 'https://www.inartists.co/post/avenir-ai-a-human-startup-built-at-the-edge-of-two-crises',
        cta: 'Read the feature',
    },
    {
        outlet: 'NABIP-MA Benefest 2026',
        title: 'Featured speaker: AI’s impact on the insurance marketplace',
        blurb: 'Maria Zou takes the Benefest stage alongside OneDigital leaders to show benefits professionals how AI is reshaping the insurance marketplace.',
        img: '/press/nabip.jpeg',
        href: 'https://www.nabip-ma.org/benefest',
        cta: 'Event details',
    },
    {
        outlet: 'Latino Tech Week',
        title: 'Named one of the 100 Best Startups',
        blurb: 'Latino Tech Week named Avenir to its 100 Best Startups, spotlighting the founders building what comes next.',
        img: '/press/latinotechweek.png',
        href: 'https://www.instagram.com/p/DY46kH2xQEW/',
        cta: 'View on Instagram',
    },
    {
        outlet: 'Influential Women',
        title: '10 Influential Women in entrepreneurship',
        blurb: 'Influential Women named co-founders Maria Zou and Ariadne Dulchinos to its National Entrepreneurship Month list of founders building lasting impact.',
        img: '/press/influentialwomen.jpeg',
        href: 'https://www.linkedin.com/feed/update/urn:li:activity:7401708044268494848/',
        cta: 'See the feature',
    },
    {
        outlet: 'Global HAIckathon · MIT CIC',
        title: 'Featured judges at the Global HAIckathon',
        blurb: 'Avenir’s founders judged a 24-hour AI hackathon running at once across Boston, NYC, London, Lisbon, and Berlin.',
        img: '/press/haickathon.jpeg',
        href: 'https://www.global-haickathon.com/',
        cta: 'Visit the HAIckathon',
    },
    {
        outlet: 'a16z Speedrun AI Faire',
        title: 'On stage at the a16z Speedrun AI Faire',
        blurb: 'Avenir demoed its AI agents for employee benefits to investors and operators at the a16z Speedrun AI Faire in Los Angeles.',
        img: '/press/aifaire.jpeg',
        href: 'https://speedrun.a16z.com/companies/avenir-ai',
        cta: 'Learn more',
    },
];

const PressCard = ({ item }) => {
    const [imgErr, setImgErr] = useState(false);
    const showImg = item.img && !imgErr;
    return (
        <article className="press-card">
            <div className="press-card-media">
                {showImg ? (
                    <img src={item.img} alt={item.outlet} loading="lazy" onError={() => setImgErr(true)} />
                ) : (
                    <div className="press-card-media-fallback"><span>{item.outlet}</span></div>
                )}
            </div>
            <div className="press-card-body">
                <span className="press-card-outlet">{item.outlet}</span>
                <h3 className="press-card-title">{item.title}</h3>
                <p className="press-card-blurb">{item.blurb}</p>
                {item.href && (
                    <a className="press-card-link" href={item.href} target="_blank" rel="noreferrer">
                        {item.cta || 'Read more'}
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M5 12h14M13 6l6 6-6 6" />
                        </svg>
                    </a>
                )}
            </div>
        </article>
    );
};

const About = () => {
    const founders = [
        {
            name: 'Maria Zou',
            role: 'Chief Executive Officer',
            photo: '/maria.jpeg',
            lines: [
                'MIT research in employee healthcare',
                'Harvard School of Public Health'
            ],
            logos: ['/mit.png', '/harvardchan.png']
        },
        {
            name: 'Ari Dulchinos',
            role: 'Chief Technology Officer',
            photo: '/ari.png',
            lines: [
                'MIT research in ML for healthcare',
                'Ex-Apple · Ex-Microsoft Copilot'
            ],
            logos: ['/mit.png', '/apple.png', '/mscopilot.png']
        }
    ];

    const aiTeam = [
        {
            name: 'Microsoft Copilot',
            role: 'AI Advisor',
            photo: '/blanksquare.jpg',
            lines: [
                'Principal Group Director',
                'AI Advisor'
            ],
            logos: ['mscopilot.png']
        },
        {
            name: 'Google DeepMind',
            role: 'AI Advisor',
            photo: '/blanksquare.jpg',
            lines: [
                'Product Lead, Gemini',
                'AI Advisor'
            ],
            logos: ['gemini.png']
        }
    ];

    const benefitsTeam = [
        {
            name: 'WTW',
            role: 'Benefits Advisor',
            photo: '/blanksquare.jpg',
            lines: [
                '30+ years in employee benefits',
                'Benefits Advisor'
            ],
            logos: ['wtw.png']
        },
        {
            name: 'Hub International',
            role: 'Benefits Advisor',
            photo: '/blanksquare.jpg',
            lines: [
                '30+ years in employee benefits',
                'Benefits Advisor'
            ],
            logos: ['hub.png']
        }
    ];

    const principles = [
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
            ),
            title: 'Security is not a feature — it\'s the foundation',
            desc: 'HIPAA compliance, SOC 2 Type II, BAAs, RBAC, audit logging, and 256-bit encryption. Built in from day one, not bolted on after.'
        },
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" />
                </svg>
            ),
            title: 'Value in days, not quarters',
            desc: 'Connect your data, pick a workflow, get a deliverable. Most teams run their first analysis within 24 hours of onboarding.'
        },
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" /><circle cx="9" cy="7" r="4" />
                    <path d="M23 21v-2a4 4 0 00-3-3.87" /><path d="M16 3.13a4 4 0 010 7.75" />
                </svg>
            ),
            title: 'Built for brokers, not built for demos',
            desc: 'Every workflow was validated with consultants managing real employer groups. If it doesn\'t save you time on a real client, it doesn\'t ship.'
        }
    ];

    return (
        <div className="page-content">
            {/* ═══════════ Hero ═══════════ */}
            <section className="hero hero-with-blob">
                <div className="blob-background">
                    <div className="blob blob-1"></div>
                    <div className="blob blob-2"></div>
                    <div className="blob blob-3"></div>
                    <div className="blob blob-4"></div>
                </div>

                <div className="hero-content">
                    <p className="hero-subtitle">Behind Avenir</p>
                    <h1 className="hero-title">
                        World-class AI meets <span className="gradient-text">deep benefits expertise</span>
                    </h1>
                    <p className="hero-description">
                        Many organizations offer AI. Very few combine frontier technology with people who have actually led benefits practices at scale. That combination is what makes Avenir different.
                    </p>
                </div>
            </section>

            {/* ═══════════ Founders ═══════════ */}
            <section className="section">
                <div className="section-center" style={{ marginBottom: '3rem' }}>
                    <h2 className="section-heading">
                        <span className="gradient-text">Founders</span>
                    </h2>
                    <p className="section-description">
                        Healthcare AI researchers from MIT who saw the gap between what's possible and what brokers actually have access to.
                    </p>
                </div>

                <div className="team-founders-grid">
                    {founders.map((person, i) => (
                        <div className="team-founder-card" key={i}>
                            <div className="team-founder-photo-wrap">
                                <img src={person.photo} alt={person.name} className="team-founder-photo" />
                            </div>
                            <div className="team-founder-info">
                                <h3 className="team-founder-name">{person.name}</h3>
                                <span className="team-founder-role">{person.role}</span>
                                <div className="team-founder-lines">
                                    {person.lines.map((line, j) => (
                                        <span key={j}>{line}</span>
                                    ))}
                                </div>
                                <div className="team-founder-logos">
                                    {person.logos.map((logo, j) => (
                                        <img key={j} src={logo} alt="" />
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* ═══════════ Two-Pillar Team ═══════════ */}
            <section className="section team-pillars-section">
                <div className="section-center" style={{ marginBottom: '3rem' }}>
                    <h2 className="section-heading">
                        <span className="gradient-text">Advisors</span>
                    </h2>
                </div>
                <div className="team-pillars">
                    {/* AI Pillar */}
                    <div className="team-pillar">
                        <div className="team-pillar-header team-pillar-header-ai">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M12 2a4 4 0 014 4v1a2 2 0 002 2h1a4 4 0 010 8h-1a2 2 0 00-2 2v1a4 4 0 01-8 0v-1a2 2 0 00-2-2H5a4 4 0 010-8h1a2 2 0 002-2V6a4 4 0 014-4z" />
                            </svg>
                            <span>Frontier AI Capabilities</span>
                        </div>
                        <div className="team-pillar-cards">
                            {aiTeam.map((person, i) => (
                                <div className="team-member-card" key={i}>
                                    <img src={person.photo} alt={person.name} className="team-member-photo" />
                                    <div className="team-member-info">
                                        <h4 className="team-member-name">{person.name}</h4>
                                        <div className="team-member-lines">
                                            {person.lines.map((line, j) => (
                                                <span key={j}>{line}</span>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="team-member-logos">
                                        {person.logos.map((logo, j) => (
                                            <img key={j} src={logo} alt="" />
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Benefits Pillar */}
                    <div className="team-pillar">
                        <div className="team-pillar-header team-pillar-header-benefits">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
                                <circle cx="9" cy="7" r="4" />
                                <path d="M23 21v-2a4 4 0 00-3-3.87" />
                                <path d="M16 3.13a4 4 0 010 7.75" />
                            </svg>
                            <span>Benefits Industry Knowledge</span>
                        </div>
                        <div className="team-pillar-cards">
                            {benefitsTeam.map((person, i) => (
                                <div className="team-member-card" key={i}>
                                    <img src={person.photo} alt={person.name} className="team-member-photo" />
                                    <div className="team-member-info">
                                        <h4 className="team-member-name">{person.name}</h4>
                                        <div className="team-member-lines">
                                            {person.lines.map((line, j) => (
                                                <span key={j}>{line}</span>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="team-member-logos">
                                        {person.logos.map((logo, j) => (
                                            <img key={j} src={logo} alt="" />
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <p className="team-pillar-footnote">
                    60+ combined years of benefits industry experience. Advisors from the teams that built Microsoft Copilot and Google Gemini.
                </p>
            </section>

            {/* ═══════════ Backed By ═══════════ */}
            <section className="section">
                <div className="section-center" style={{ marginBottom: '3rem' }}>
                    <h2 className="section-heading">
                        Backed by <span className="gradient-text">leading institutions</span>
                    </h2>
                    <p className="section-description">
                        Supported by grants, accelerators, and awards from the institutions advancing healthcare and technology.
                    </p>
                </div>

                <div className="stats-box">
                    <div className="trusted-logos">
                        <img src="/mtc.png" alt="MIT Martin Trust Center" />
                        <img src="/deltav.png" alt="deltaV" />
                        <img src="/harvardchan.png" alt="Harvard Chan" />
                        <img src="/mec.png" alt="MEC" />
                        <img src="/mit100k.png" alt="MIT 100K" />
                        <img src="/hms.webp" alt="Harvard Medical School" />
                        <img src="/sandbox.png" alt="Sandbox" />
                        <img src="/a16z.png" alt="a16z Speedrun" />
                    </div>
                    <div className="stats-grid">
                        <div className="stat">
                            <div className="stat-value">$1M+</div>
                            <div className="stat-label">raised in 90 days</div>
                        </div>
                        <div className="stat">
                            <div className="stat-value">500+</div>
                            <div className="stat-label">broker & employer interviews</div>
                        </div>
                        <div className="stat">
                            <div className="stat-value">a16z</div>
                            <div className="stat-label">Speedrun alumni</div>
                        </div>
                        <div className="stat">
                            <div className="stat-value">MIT</div>
                            <div className="stat-label">healthcare AI research</div>
                        </div>
                        <div className="stat">
                            <div className="stat-value">10×</div>
                            <div className="stat-label">faster time-to-insight</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ═══════════ Principles ═══════════ */}
            <section className="section">
                <div className="section-center" style={{ marginBottom: '4rem' }}>
                    <h2 className="section-heading">
                        How we <span className="gradient-text">build</span>
                    </h2>
                </div>

                <div className="principles-grid">
                    {principles.map((principle, i) => (
                        <div key={i} className="principle-card">
                            <div className="principle-icon-wrap">
                                {principle.icon}
                            </div>
                            <h3 className="principle-title">{principle.title}</h3>
                            <p className="principle-desc">{principle.desc}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* ═══════════ Press ═══════════ */}
            <section className="section">
                <div className="section-center" style={{ marginBottom: '3rem' }}>
                    <h2 className="section-heading">
                        In the <span className="gradient-text">press</span>
                    </h2>
                    <p className="section-description">
                        Features, recognition, and the stages where Avenir is shaping the conversation on AI in benefits.
                    </p>
                </div>

                <div className="press-grid">
                    {PRESS.map((item, i) => (
                        <PressCard key={i} item={item} />
                    ))}
                </div>
            </section>

            {/* ═══════════ CTA ═══════════ */}
            <section className="section">
                <div className="cta-wrapper">
                    <div className="cta-glow"></div>
                    <div className="cta-box">
                        <h2 className="cta-title">See what Avenir finds in your data</h2>
                        <p className="cta-desc">Bring a client's claims file to a 30-minute demo. We'll run a live analysis — no pitch deck, no commitment.</p>
                        <div className="cta-buttons">
                            <Link to="/contact" className="btn btn-primary btn-large">Book a Live Demo</Link>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default About;